module.exports = __webpack_public_path__ + "static/img/Inspection3.a4c01365.png";